import { IAvailableRating } from '../../types/rating';
import { ITypedReduxAction } from '../../types/redux/actionType';
import { ITag } from '../../types/tag';

export enum EFiltersActionTypes {
  ToggleRatingFilter = 'FILTERS/TOGGLE_RATING_FILTER',
  SetRatingFilters = 'FILTERS/SET_RATING_FILTERS',
  ToggleTagFilter = 'FILTERS/TOGGLE_TAG_FILTER',
  SetTagFilters = 'FILTERS/SET_TAG_FILTERS',
  ClearFilters = 'FILTERS/CLEAR',
}

export type TToggleRatingFilterType = ITypedReduxAction<EFiltersActionTypes.ToggleRatingFilter, number>;

export type TSetRatingFilters = ITypedReduxAction<EFiltersActionTypes.SetRatingFilters, IAvailableRating[]>;

export type TToggleTagFilterType = ITypedReduxAction<EFiltersActionTypes.ToggleTagFilter, string>;

export type TSetTagsFilters = ITypedReduxAction<EFiltersActionTypes.SetTagFilters, ITag[]>;

export type TClearFilters = ITypedReduxAction<EFiltersActionTypes.ClearFilters>;

export type TFiltersActions =
  | TToggleRatingFilterType
  | TSetRatingFilters
  | TToggleTagFilterType
  | TSetTagsFilters
  | TClearFilters;
